import React from 'react'
import OrderConfirmation from './orderTracking.js'
const Order = () => {
  return (
    <div>
        <OrderConfirmation />
    </div>
  )
}

export default Order
